import NoDataMessage from './NoDataMessage';
import { Box, Grid2 } from '@mui/material';
import ConsultCard from './ConsultCard';
import CustomTypography from '@qler-view/shared_lib/src/shared/lib/ui-components/Typography/CustomTypography';
import type { ConsultItem } from '../../API/services/caseManagerServices';

type ConsultListProps = {
  consults: ConsultItem[];
  emptyMessage: string;
  isRequestedByOthers?: boolean;
  loading?: boolean;
  pastConsult?: boolean;
  onAccept: () => void;
};

const ConsultListRender = ({
  consults,
  emptyMessage,
  isRequestedByOthers = false,
  loading = false,
  pastConsult = false,
  onAccept,
}: ConsultListProps) => {
  if (loading) {
    return (
      <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 4 }} className="button-width">
        <Box className="text-align-center no-consults-data">
          <CustomTypography id="loading-text" variant="h5" color="textDisabled">
            Loading...
          </CustomTypography>
        </Box>
      </Grid2>
    );
  }

  return (
    <>
      {consults.length > 0 ? (
        consults.map((consult) => (
          <Grid2
            key={consult.consultId}
            size={{ xs: 12, sm: 12, md: 6, lg: 4 }}
          >
            <ConsultCard
              consultData={consult}
              assigned={!!consult.acceptedProviderId}
              isAssigned={false}
              pastConsult={pastConsult}
              onAccept={onAccept}
              isButtonRequired={!isRequestedByOthers}
              isRequestedByOthers={isRequestedByOthers}
            />
          </Grid2>
        ))
      ) : (
        <NoDataMessage message={emptyMessage} />
      )}
    </>
  );
};

export default ConsultListRender;
